<template>
    <button
        class="toggle_elements_btn tooltipElement"
        @click="toggleElements"
    >
        <inline-svg v-if="elementsVisible"
            :src="visibility_on_icon"
            fill="#737373"
        />
        <inline-svg v-else
            :src="visibility_off_icon"
            fill="#737373"
        />
        <Tooltip :tooltipText="`${ $t('editorSceneElementOptionsSetVisibility') }`" />
    </button>
</template>

<script>
    import { mapState } from 'vuex';
    import Tooltip from '../../Global/Tooltip.vue';
    import visibility_on_icon from '@/assets/icons/visibility_on.svg';
    import visibility_off_icon from '@/assets/icons/visibility_off.svg';

    export default {
        data() {
            return {
                visibility_on_icon,
                visibility_off_icon
            }
        },
        methods: {
            toggleElements() {
                this.$store.dispatch('TOGGLE_ELEMENTS')
            }
        },
        computed: {
            ...mapState([
                'elementsVisible'
            ])
        },
        components: {
            Tooltip
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/setup/_variables.scss';

    .toggle_elements_btn {
        background-color: unset;
        border: none;
        margin-right: 10px;
        cursor: pointer;
        display: flex;
        align-content: center;
        justify-content: center;
    }
</style>